export default __webpack_public_path__ + "static/media/foam.b1f585a6.jpg";